import svg4everybody from 'svg4everybody'

import createPortfolioslider from './modules/createPortfolioslider'
import createPortfoliofilter from './modules/createPortfoliofilter'
import createFeaturedShipsSlider from './modules/createFeaturedShipsSlider'

import './polyfills/classlist'
// CUSTOM MODULES
// import Styleguide from './modules/Styleguide';

/**
 *  App class
 *
 *  The App class functions a the main back-bone of the javascript used in this
 *  project.
 *
 */

class App {
  /**
   *  Constructor
   */
  constructor() {
    this.onDocumentReady(this.init)
  }

  onDocumentReady(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      // call on next available tick
      setTimeout(fn, 1)
    } else {
      document.addEventListener('DOMContentLoaded', fn)
    }
  }

  init() {
    svg4everybody()
  }

  handleStyleguide() {
    new Styleguide()
  }

  initPortfolioSlider(el) {
    createPortfolioslider(el)
  }

  initPortfolioFilter() {
    createPortfoliofilter()
  }

  initFeaturedShipsSlider(el) {
    createFeaturedShipsSlider(el)
  }
}

window.app = new App()
